/**
 * Scheduler Procurement - Main Entry Point
 *
 * Procurement workbench for:
 * - Shortage tracking and ordering
 * - PO confirmation management
 * - Shipment tracking
 * - Demand forecasting
 *
 * See DESIGN-SYSTEM.md for UI standards.
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { ErrorBoundary } from './components/ErrorBoundary';
import { AppLayout } from './components/AppLayout';
import { NotFoundPage } from './pages/NotFoundPage';
import { ToOrderPage } from './pages/ToOrderPage';
import { ConfirmationPage } from './pages/ConfirmationPage';
import { ShipmentPage } from './pages/ShipmentPage';
import { ForecastPage } from './pages/ForecastPage';
import { InventoryPage } from './pages/InventoryPage';

import './index.css';

// Configure React Query client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});


function App() {
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <AppLayout>
            <Routes>
              <Route path="/" element={<ToOrderPage />} />
              <Route path="/confirmation" element={<ConfirmationPage />} />
              <Route path="/shipment" element={<ShipmentPage />} />
              <Route path="/forecast" element={<ForecastPage />} />
              <Route path="/inventory" element={<InventoryPage />} />
              {/* Catch-all for 404 */}
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </AppLayout>
        </BrowserRouter>
      </QueryClientProvider>
    </ErrorBoundary>
  );
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
